<div class="container">
  <mic-breadcrumb id="casing-grade-table-details-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/productData/casing-grade-table"
      label="{{ translationService.translate('casingGradeTableText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('casingGradeTableDetailsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title" id="casing-grade-table-details-heading">{{ translationService.translate('casingGradeTableDetailsText') }}</h2>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="w-full flex flex-row items-center justify-between">
        <div class="filter-button-wrapper">
          <div class="grid-container" style="margin-left: 25px">
            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>{{ translationService.translate('casingGradeTableCodeText') }}</mat-label>
              <input
                #casingGradeTableCodeInput
                matInput
                formControlName="casingGradeTableCode"
                [readonly]="mode === 'edit'"
                [attr.disabled]="mode === 'edit' ? true : null"
                placeholder="{{ translationService.translate('enterCasingGradeCodeText') }}"
                (keydown.enter)="$event.preventDefault()"
                (blur)="checkIfCasingGradeCodeExists()"
                maxlength="20"
              />
              @if (mode !== 'edit' && filterForm.get('casingGradeTableCode').hasError('required')) {
              <mat-error>{{ translationService.translate('thisIsMandatoryFieldText') }}</mat-error>
              } @if (mode !== 'edit' && filterForm.get('casingGradeTableCode').hasError('exists')) {
              <mat-error>{{ translationService.translate('codeExistsText') }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>{{ translationService.translate('casingGradeTableDescText') }}</mat-label>
              <input
                matInput
                formControlName="casingGradeTableDesc"
                [readonly]="mode === 'edit'"
                [attr.disabled]="mode === 'edit' ? true : null"
                placeholder="{{ translationService.translate('enterCasingGradeDescText') }}"
              />
              @if (mode !== 'edit' && filterForm.get('casingGradeTableDesc').hasError('required')) {
              <mat-error>{{ translationService.translate('thisIsMandatoryFieldText') }}</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="button-container">
            <button id="cancel-button" class="btn-cancel" mat-flat-button (click)="onCancel()" [disabled]="isSaving">
              <mat-icon>cancel</mat-icon> {{ translationService.translate('cancelText') }}
            </button>
            <button
              id="save-button"
              class="btn-primary"
              type="button"
              mat-flat-button
              color="primary"
              [disabled]="!canEditCasingGrade || isSaving"
              (click)="onSave()"
            >
              @if (isSaving) {
              <mat-spinner diameter="20" style="display: inline-block; margin-right: 8px"></mat-spinner>
              } @if (!isSaving) {
              <mat-icon>save</mat-icon>
              }
              {{ isSaving ? translationService.translate('savingText') : translationService.translate('saveLinkText') }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </mat-card>

  <div style="margin-top: 10px">
    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="folder"></mic-icon>
            {{ translationService.translate('defaultCasingGradeText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div [formGroup]="filterForm">
          <!-- Default Values needs to be displayed-->
          <div class="grid-container">
            <mic-dropdown-search
              micDropdownAccessibility
              id="defaultCasingGrade"
              appearance="outline"
              label="{{ translationService.translate('defaultCasingGradeText') }}"
              emptyPlaceholder="{{ translationService.translate('noDataFoundText') }}"
              placeholder="{{ translationService.translate('selectCasingGradeText') }}"
              formControlName="defaultCasingGrade"
              [required]="true"
              [widthConfig]="{ width: '100%' }"
              [data]="defaultCasingGrade"
            >
            </mic-dropdown-search>

            <mic-dropdown-search
              micDropdownAccessibility
              id="rmCasingPrefix"
              label="{{ translationService.translate('rmCasingPrefixText') }}"
              emptyPlaceholder="{{ translationService.translate('noDataFoundText') }}"
              placeholder="{{ translationService.translate('selectrmCasingPrefixText') }}"
              formControlName="rmCasingPrefix"
              [data]="getPrefixSuffixList()"
              [widthConfig]="{ width: '100%' }"
              appearance="outline"
            >
            </mic-dropdown-search>

            <mic-dropdown-search
              micDropdownAccessibility
              id="rmCasingSuffix"
              label="{{ translationService.translate('rmCasingSuffixText') }}"
              emptyPlaceholder="{{ translationService.translate('noDataFoundText') }}"
              placeholder="{{ translationService.translate('selectrmCasingSuffixText') }}"
              formControlName="rmCasingSuffix"
              [widthConfig]="{ width: '100%' }"
              [data]="getPrefixSuffixList()"
              appearance="outline"
            >
            </mic-dropdown-search>

            <mic-dropdown-search
              micDropdownAccessibility
              id="fgCasingSuffix"
              label="{{ translationService.translate('fgCasingSuffixText') }}"
              emptyPlaceholder="{{ translationService.translate('noDataFoundText') }}"
              placeholder="{{ translationService.translate('selectfgCasingSuffixText') }}"
              formControlName="fgCasingSuffix"
              [widthConfig]="{ width: '100%' }"
              [data]="getPrefixSuffixList()"
              appearance="outline"
            >
            </mic-dropdown-search>

            <mic-dropdown-search
              micDropdownAccessibility
              id="fgCapPrefix"
              label="{{ translationService.translate('fgCapPrefixText') }}"
              emptyPlaceholder="{{ translationService.translate('noDataFoundText') }}"
              placeholder="{{ translationService.translate('selectfgCapPrefixText') }}"
              formControlName="fgCapPrefix"
              [data]="getPrefixSuffixList()"
              [widthConfig]="{ width: '100%' }"
              appearance="outline"
            >
            </mic-dropdown-search>

            <mic-dropdown-search
              micDropdownAccessibility
              id="fgCasingPrefix"
              label="{{ translationService.translate('fgCasingPrefixText') }}"
              emptyPlaceholder="{{ translationService.translate('noDataFoundText') }}"
              placeholder="{{ translationService.translate('selectfgCasingPrefixText') }}"
              formControlName="fgCasingPrefix"
              [data]="getPrefixSuffixList()"
              [widthConfig]="{ width: '100%' }"
              appearance="outline"
            >
            </mic-dropdown-search>

            <mic-dropdown-search
              micDropdownAccessibility
              id="fgCapSuffix"
              label="{{ translationService.translate('fgCapSuffixText') }}"
              emptyPlaceholder="{{ translationService.translate('noDataFoundText') }}"
              placeholder="{{ translationService.translate('selectfgCapSuffixText') }}"
              formControlName="fgCapSuffix"
              [widthConfig]="{ width: '100%' }"
              [data]="getPrefixSuffixList()"
              appearance="outline"
            >
            </mic-dropdown-search>
          </div>
        </div>
        <!--      </mat-card>-->
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div style="margin-top: 10px">
    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="folder"></mic-icon>
            {{ translationService.translate('specificCasingGradeText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>

        <div class="button-container">
          <button
            id="add-button"
            class="btn-primary"
            type="button"
            mat-flat-button
            color="primary"
            (click)="onAddNewRule()"
            [disabled]="!canEditCasingGrade || isSaving || isDeleting"
          >
            <mat-icon>add</mat-icon> {{ translationService.translate('addNewRuleText') }}
          </button>
        </div>

        <!--        <div *ngIf="!isSpecLoading; else loadingSpecTable">-->
        <!-- Specification Values needs to be displayed-->
        <div id="casing-grade-table" class="cam-table cam-table-container mt-2">
          <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
            <ng-container *micTableNoData>
              <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
            </ng-container>

            <!-- Input fields for numeric columns -->
            <ng-container *micCellTemplate="let item; name: 'makeTier'">
              <input
                id="makeTierInput"
                matInput
                type="number"
                min="0"
                maxlength="1"
                style="width: 3em"
                [formControl]="getControl(item, 'casingGradeTier')"
                data-field="makeTier"
                (input)="onEnforceThreeDigits($event)"
              />
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'ntr'">
              <input
                matInput
                type="number"
                min="0"
                maxlength="2"
                style="width: 3em"
                [formControl]="getControl(item, 'casingGradeNtr')"
                data-field="ntr"
                (input)="onEnforceThreeDigits($event)"
              />
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'ageMonths'">
              <input
                matInput
                type="number"
                min="0"
                maxlength="3"
                style="width: 3em"
                [formControl]="getControl(item, 'casingGradeAge')"
                data-field="ageMonths"
                (input)="onEnforceThreeDigits($event)"
              />
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'sizeTier'">
              <input
                matInput
                type="number"
                min="0"
                maxlength="1"
                style="width: 3em"
                [formControl]="getControl(item, 'casingGradeCasingSize')"
                data-field="sizeTier"
                (input)="onEnforceThreeDigits($event)"
              />
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'nail'">
              <input
                matInput
                type="number"
                min="0"
                maxlength="2"
                style="width: 3em"
                [formControl]="getControl(item, 'casingGradeNail')"
                data-field="nail"
                (input)="onEnforceThreeDigits($event)"
              />
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'rnailCrown'">
              <input
                matInput
                type="number"
                min="0"
                maxlength="2"
                style="width: 3em"
                [formControl]="getControl(item, 'casingGradeRnailCrown')"
                data-field="rnailCrown"
                (input)="onEnforceThreeDigits($event)"
              />
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'rnailShoulder'">
              <input
                matInput
                type="number"
                min="0"
                maxlength="2"
                style="width: 3em"
                [formControl]="getControl(item, 'casingGradeRnailShoulder')"
                data-field="rnailShoulder"
                (input)="onEnforceThreeDigits($event)"
              />
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'sr'">
              <input
                matInput
                type="number"
                min="0"
                maxlength="2"
                style="width: 3em"
                [formControl]="getControl(item, 'casingGradeSr')"
                data-field="sr"
                (input)="onEnforceThreeDigits($event)"
              />
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'max'">
              <input
                matInput
                type="number"
                min="0"
                max="999.99"
                maxlength="3"
                style="width: 3em"
                [formControl]="getControl(item, 'casingGradeMaxRepairs')"
                data-field="max"
                (input)="onEnforceThreeDigits($event)"
              />
            </ng-container>

            <!-- Dropdown for axle -->
            <ng-container *micCellTemplate="let item; name: 'axle'">
              <mic-dropdown-search
                micDropdownAccessibility
                class="wide-dropdown"
                emptyPlaceholder="No data found"
                [data]="axleOptions"
                [formControl]="getControl(item, 'casingGradeAxle')"
                data-field="axle"
                appearance="outline"
                [widthConfig]="{ width: '100%' }"
                label="{{ this.translationService.translate('axleText') }}"
              ></mic-dropdown-search>
            </ng-container>

            <!-- Dropdown for grade -->
            <ng-container *micCellTemplate="let item; name: 'grade'">
              <mic-dropdown-search
                micDropdownAccessibility
                class="wide-dropdown"
                emptyPlaceholder="No data found"
                [data]="defaultCasingGrade"
                [formControl]="getControl(item, 'casingGrade')"
                data-field="grade"
                [required]="true"
                appearance="outline"
                [widthConfig]="{ width: '100%' }"
                label="{{ this.translationService.translate('gradeText') }}"
              ></mic-dropdown-search>
            </ng-container>

            <!-- Dropdowns for casing/cap prefix/suffix fields -->
            <ng-container *micCellTemplate="let item; name: 'rmCasingPrefix'">
              <mic-dropdown-search
                micDropdownAccessibility
                class="wide-dropdown"
                emptyPlaceholder="No data found"
                [data]="getPrefixSuffixList()"
                [formControl]="getControl(item, 'rmCasingPrefix')"
                data-field="rmCasingPrefix"
                appearance="outline"
                [widthConfig]="{ width: '100%' }"
                label="{{ this.translationService.translate('rmCasingPrefixText') }}"
              ></mic-dropdown-search>
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'rmCasingSuffix'">
              <mic-dropdown-search
                micDropdownAccessibility
                class="wide-dropdown"
                emptyPlaceholder="No data found"
                [data]="getPrefixSuffixList()"
                [formControl]="getControl(item, 'rmCasingSuffix')"
                data-field="rmCasingSuffix"
                appearance="outline"
                [widthConfig]="{ width: '100%' }"
                label="{{ this.translationService.translate('rmCasingSuffixText') }}"
              ></mic-dropdown-search>
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'fgCasingPrefix'">
              <mic-dropdown-search
                micDropdownAccessibility
                class="wide-dropdown"
                emptyPlaceholder="No data found"
                [data]="getPrefixSuffixList()"
                [formControl]="getControl(item, 'fgCasingPrefix')"
                data-field="fgCasingPrefix"
                appearance="outline"
                [widthConfig]="{ width: '100%' }"
                label="{{ this.translationService.translate('fgCasingPrefixText') }}"
              ></mic-dropdown-search>
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'fgCasingSuffix'">
              <mic-dropdown-search
                micDropdownAccessibility
                class="wide-dropdown"
                emptyPlaceholder="No data found"
                [data]="getPrefixSuffixList()"
                [formControl]="getControl(item, 'fgCasingSuffix')"
                data-field="fgCasingSuffix"
                appearance="outline"
                [widthConfig]="{ width: '100%' }"
                label="{{ this.translationService.translate('fgCasingSuffixText') }}"
              ></mic-dropdown-search>
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'fgCapCasingPrefix'">
              <mic-dropdown-search
                micDropdownAccessibility
                class="wide-dropdown"
                emptyPlaceholder="No data found"
                [data]="getPrefixSuffixList()"
                [formControl]="getControl(item, 'fgCapCasingPrefix')"
                data-field="fgCapCasingPrefix"
                appearance="outline"
                [widthConfig]="{ width: '100%' }"
                label="{{ this.translationService.translate('fgCapPrefixText') }}"
              ></mic-dropdown-search>
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'fgCapCasingSuffix'">
              <mic-dropdown-search
                micDropdownAccessibility
                class="wide-dropdown"
                emptyPlaceholder="No data found"
                [data]="getPrefixSuffixList()"
                [formControl]="getControl(item, 'fgCapCasingSuffix')"
                data-field="fgCapCasingSuffix"
                appearance="outline"
                [widthConfig]="{ width: '100%' }"
                label="{{ this.translationService.translate('fgCapSuffixText') }}"
              ></mic-dropdown-search>
            </ng-container>

            <ng-container *micCellTemplate="let item; name: 'action'">
              <div class="centered-cell">
                <button
                  mat-icon-button
                  [disabled]="!canEditCasingGrade || isSaving || isDeleting"
                  (click)="showDeleteModal(item)"
                  [matTooltip]="
                    canEditCasingGrade ? translationService.translate('deleteText') : translationService.translate('noEditPermissionText')
                  "
                  matTooltipPosition="above"
                >
                  <mic-icon class="m" icon="delete" fontSet="filled"></mic-icon>
                </button>
              </div>
            </ng-container>
          </mic-table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <mic-modal class="modalC" #deleteConfirmation (result)="onDeleteModalClosed($event)"></mic-modal>
  <ng-template #deleteContent>{{ translationService.translate('deleteCasingGradeTableConfirmText') }}</ng-template>
  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>
    <div class="discard-message">
      {{ discardMessage || translationService.translate('unSaveChangesText') }}
    </div>
  </ng-template>
</div>
